export const QUOTE_FEEDERS_TABLE_NAME = "AvailableQuoteFeeders";

export const QUOTE_FEEDERS_TABLE_HEADER = ["Quote Feeder", "ID"];

export const QUOTE_FEEDERS_NAMES_COL = "F";
